<nz-breadcrumb nzSeparator=">" [nzAutoGenerate]="true" [nzRouteLabel]="'breadcrumbI18nKey'">
  <nz-breadcrumb-item>
    <a [href]="getBackOfficeUrl()">
      {{ 'common.label.backOffice' | translate }}
    </a>
  </nz-breadcrumb-item>
</nz-breadcrumb>
